import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'
import {useCurrentUser} from "@/hooks/useCurrentUser";
import {useUser} from "@clerk/shared/react";

let isIdentified = false
export const usePosthogIdentify = (): void => {
  const posthog = usePostHog()
  const { data: user } = useCurrentUser()
  const { user: clerkUser } = useUser()

  useEffect(() => {
    if(!posthog) {
      return
    }
    if (user && clerkUser && !isIdentified) {
      posthog.identify(user.id.toString(), {
        username: user.username,
        user_id: user.id.toString(),
        clerk_id: clerkUser.id,
        has_glasspass: user.has_glasspass,
        glasspass_type: user.glasspass?.type,
        glasspass_expires_at: user.glasspass?.expires_at,
        accepts_marketing: user.accepts_marketing,
        is_staff: user.is_staff,
        is_shardsmith: user.is_shardsmith,
        created_at: user.date_joined
      })
      isIdentified = true
    } else if((!user || !clerkUser) && isIdentified) {
      posthog.identify(undefined)
      isIdentified = false
    }
  }, [user, clerkUser, posthog])
}
